module.exports = __webpack_public_path__ + "static/img/play-multiplayers-square.dd97659.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play-multiplayers-square.jpg
// module id = mBvf
// module chunks = 1